import React, { useState, useEffect } from 'react'
import { Link, useParams  } from 'react-router-dom';
import axios from 'axios'
import { Markup } from 'interweave';
import { ReactSession } from 'react-client-session';

import noThumb from "../../../images/no-thumb.jpg";

import classes from './RelatedVideos.module.css'

function ReletedVideos() {
    const { id } = useParams();
    const [reletedVideos, setReletedVideos] = useState([]);
    ReactSession.setStoreType("localStorage");

    useEffect(() => {
        try{
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }catch(ex){}
    }, []);

    useEffect(() => {
        if(!ReactSession.get('autoplay')) {
            ReactSession.set('autoplay', false);
        }else {
            document.querySelector('#autoplayHandler').checked = ReactSession.get('autoplay');
        }
    }, [id]);

    useEffect(() => {
        // Related Videos
        axios.get(`${process.env.REACT_APP_API_URL}/api/related.php?type=all&id=${id}`)
        .then(response => {
            setReletedVideos(response.data);
        })
        .catch(error => {
            console.log(error);
        })
    }, [id]);

    const autoplayHandler = () => {
        const checkall = document.querySelector('#autoplayHandler');
        if(checkall.checked) {
            ReactSession.set('autoplay', true);
        }else {
            ReactSession.set('autoplay', false);
        }
    }

  return (
    <>
        <ins className='adsbygoogle mb-4'
            style={{ display: 'block' }}
            data-ad-client='ca-pub-8126596259429304'
            data-ad-slot='3209374230'
            data-ad-format='auto'
        />
        <div className={classes.caption}>
            <div className={classes.top}>
                <div className={classes.left}>
                    <span>Up Next</span>
                </div>
                    <div className={classes.right}>
                        <input type="checkbox" name="autoplay" id="autoplayHandler" onClick={() => autoplayHandler()} />
                    <span>Autoplay</span>
                </div>
            </div>
            <div className={`loading_bar ${classes.loading_bar}`}>
                <div className={classes.progress_bar}></div>
            </div>
        </div>
        <div className={classes.list}>
            {
                reletedVideos && reletedVideos.map && reletedVideos.map((video, index) => {
                    let thumb = null;
                    if(video.thumb.includes('storage/media/thumbs/')) {
                        thumb = `${process.env.REACT_APP_API_URL}/${video.thumb}`;
                    }else {
                        thumb = video.thumb;
                    }
                    return (
                        <div id={`video_${video.id}`} className={`row ${classes.video} ${index === 0 ? ' autoPlay' : ''}`} key={index}>
                            <div className="col-lg-6 col-sm-6">
                                <div className={classes.thumb}>
                                    <Link to={`/play/${video.id}/${video.nice_url}`}>
                                        <img src={thumb} onError={e => {e.target.src = noThumb}} alt="thumb" />
                                    </Link>
                                    {
                                        (video.duration > 0) && <div className={classes.duration}>{video.video_time}</div>
                                    }
                                </div>
                            </div>
                            <div className="col-lg-6 col-sm-6">
                                <div className={classes.title}>
                                    <Link to={`/play/${video.id}/${video.nice_url}`}><Markup content={video.title}></Markup></Link>
                                </div>
                                <div className={classes.uploaderlink}><Link to={`/profile/${video.user_id}/${video.username}`}>{video.name}</Link></div>
                                <div className={classes.views}>{video.views} views</div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    </>
  )
}

export default ReletedVideos